// Market Visit Report Service
// Consolidated API layer - all methods accept payloads directly

import { addMarketVisitReportApi } from "@services/MarketVisitReport/addMarketVisitReportApi";
import { updateMarketVisitReportApi } from "@services/MarketVisitReport/updateMarketVisitReportApi";
import { getMarketVisitReportApi } from "@services/MarketVisitReport/getMarketVisitReportApi";
import { getMvrFormDateApi } from "@services/MarketVisitReport/getMvrFormDate";
import { deleteSaveAsDraftForMVRApi } from "@services/MarketVisitReport/deleteSaveAsDraftForMVRAPI";
import { addEscalationServiceRequestApi } from "@services/MarketVisitReport/addEscalationServiceRequestApi";
import { getMvrSrAttachedFiles } from "@services/MarketVisitReport/getSrAttachedFiles";
import { getMVRDealerNameApi } from "@services/MarketVisitReport/getDealerNameApi";
import { getMVRDealerNameForHOApi } from "@services/MarketVisitReport/getMVRDealerNameForHOApi";
import { getZSMWssNameApi } from "@services/zsm/getZSMWssNameApi";
import { getVlcUsersApi } from "@services/MarketVisitReport/getVLCsUserApi";

/**
 * Market Visit Report Service
 * Handles all API calls for Market Visit Report feature
 * All thunk-based APIs require dispatch to be passed in.
 */
export const marketVisitReportService = {
  /**
   * Submit market visit report
   */
  submitReport: async (dispatch, payload) => {
    return await dispatch(addMarketVisitReportApi(payload));
  },

  /**
   * Update draft report
   */
  updateDraft: async (dispatch, payload) => {
    return await dispatch(updateMarketVisitReportApi(payload));
  },

  /**
   * Get market visit report by user and date
   */
  getReport: async (dispatch, userId, date) => {
    return await dispatch(getMarketVisitReportApi(date, userId));
  },

  /**
   * Get form dates for current month
   */
  getFormDates: async (userId) => {
    return await getMvrFormDateApi(userId);
  },

  /**
   * Delete draft
   */
  deleteDraft: async (dispatch, draftId) => {
    return await dispatch(deleteSaveAsDraftForMVRApi(draftId));
  },

  /**
   * Submit escalation service request
   */
  submitEscalation: async (dispatch, payload) => {
    return await dispatch(addEscalationServiceRequestApi(payload));
  },

  /**
   * Get SR attached files
   */
  getSRAttachedFiles: async (recordId) => {
    return await getMvrSrAttachedFiles(recordId);
  },

  /**
   * Get dealer names for MVR (BM user)
   */
  getDealerNames: async (dispatch, shCode) => {
    return await dispatch(getMVRDealerNameApi(shCode));
  },

  /**
   * Get dealer names for HO user
   */
  getDealerNamesForHO: async (dispatch, divisionCode, salesGroup, clusterCode) => {
    return await dispatch(getMVRDealerNameForHOApi(divisionCode, salesGroup, clusterCode));
  },

  /**
   * Get WSS names
   */
  getWSSNames: async (dispatch, clusterCode) => {
    return await dispatch(getZSMWssNameApi(clusterCode));
  },

  /**
   * Get VLC users
   */
  getVLCUsers: async (rbdmCode) => {
    return await getVlcUsersApi(rbdmCode);
  },
};
